const $ = jQuery.noConflict();



$(document).ready(function () {

  setInterval(function () {
    // Remove google branded background image from desktop search input box.
    $('#gsc-i-id2').attr('style', '');
  }, 10);
  /* Pagination control By default, Google displays 10 pages. Per comps, we added previous/left and next/right arrows and collapsed the total number of pages to 5. */
  if ($('#search').length > 0) {

    setInterval(function () {
      if ($('.gsc-cursor-box .gsc-cursor').length > 0) {
        if ($('.pagination-container').length === 0) {
          $('.gsc-cursor-box.gs-bidi-start-align').wrap('<div class="pagination-container"></div>');
          $('.pagination-container').prepend('<div class="gsc-cursor-page arrow-left"></div>');
          $('.pagination-container').append('<div class="gsc-cursor-page arrow-right"></div>');

          $('.gsc-cursor-page.arrow-left').bind('click', function () {
            $('.gsc-cursor-box.gs-bidi-start-align').scrollTo('-=167px', 500);
          });

          $('.gsc-cursor-page.arrow-right').bind('click', function () {
            $('.gsc-cursor-box.gs-bidi-start-align').scrollTo('+=167px', 500);
          });

          $('.gsc-cursor-box.gs-bidi-start-align').scrollTo($('.gsc-cursor-current-page'));
        }
      }
    }, 500);

  }

});
